import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ValueWardrobe from './ValueWardrobe';
import BottomColContent1 from './BottomColContent1';
import BottomColContent2 from './BottomColContent2';
import KeyFeaturesWardrobe from './KeyFeatures';

function WardrobeAfter() {

    const [data,setData]=useState([])
    useEffect(()=>{
        axios.get('https://www.kitchendesign.ae/apis/wp-json/api/v4/getwardrobepage??????????')
        .then(res=>{
            setData(res.data);
        })
        .catch(err=>{
            // console.log(err);
        })
    },[])
    console.log(data);
return (
  <div className="WardrobesAfter"> 
    <ValueWardrobe image={data.acf?.values_image} heading={data.acf?.values_heading} content={data.acf?.values_content} getKeypointsList={data.acf?.values_keypoints}/>
    <BottomColContent1 image={data.acf?.spaces_image} content={data.acf?.spaces_content}/>
    <BottomColContent2 image={data.acf?.house_value_image} content={data.acf?.house_value_content}/>
    <KeyFeaturesWardrobe contentLeft={data.acf?.key_features_content} contentRight={data.acf?.why_choose_content}/>
  </div>
)
}

  export default WardrobeAfter;